// extracted by mini-css-extract-plugin
module.exports = {"page":"B_page__2naqE"};